// extracted by mini-css-extract-plugin
module.exports = {"base":"Breadcrumb_base__Rnnjl","list":"Breadcrumb_list__Cf15A","item":"Breadcrumb_item__T8wHZ"};